import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { ValueBadges } from './ValueBadges';
import { checkoutUrl, ctaLabelAccess, finalIncludedItems, trackCheckout } from '../data/offer';
const noMoreItems = ['No more Sunday evenings searching for technical progressions that actually work', 'No more classes that feel rushed or improvised', 'No more students losing motivation because sessions feel repetitive', 'No more weekends lost planning instead of living', 'No more walking onto the mat wishing you had prepared more'];
const trustItems = ['7-Day Money Back Guarantee', 'Secure Payment', 'Immediate Access', 'Pay in Your Local Currency'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-carbon-graphite" data-id="element-146" data-mp="qw6sekunohq4">
      <div className="max-w-4xl mx-auto" data-id="element-147" data-mp="14uwtebklj1jr">
        <div className="text-center mb-16" data-id="element-148" data-mp="14vpqslxo0ep8">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-149" data-mp="zwmxfyr1rwx3">
            Next Monday you can keep building your lessons from scratch...
            <br data-id="element-150" data-mp="2c7107tri8hsr" />
            <span className="text-gold" data-id="element-151" data-mp="2h3hoqp2m8y6d">
              Or you can walk onto the mat with everything ready — starting today.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-carbon p-8 rounded-2xl border border-carbon-line" data-id="element-152" data-mp="2m19ilomtmud7">
            {noMoreItems.map(item => <div key={item} className="flex items-start gap-3" data-id="element-153" data-mp="2v4aih7l3fp8f">
                <span className="text-gold mt-0.5" aria-hidden="true" data-id="element-154" data-mp="302lunoyv2btt">▸</span>
                <span className="text-mist" data-id="element-155" data-mp="300itc8s9cw9s">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-2" data-id="element-156" data-mp="34voev6hr08xc">
            Brazilian Jiu Jitsu Coach Ready does not make you a better instructor.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-157" data-mp="3esb1o0tmxa20">You are already a great instructor.</p>
          <p className="text-xl text-mist mb-16" data-id="element-158" data-mp="3isblk0zi6dgg">
            What BJJ Coach Ready does is give you the time and the tools to make
            that visible in every single class you teach.
          </p>
        </div>

        <div className="bg-carbon border-2 border-gold rounded-3xl p-6 md:p-12" data-id="element-159" data-mp="1eqjr1ions1v7">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-gold/30 pb-6 font-serif" data-id="element-160" data-mp="1sgx4g0kbk8rx">
            Everything included in the <span className="text-gold" data-id="element-161" data-mp="1nnu3v8h4jz28">6-in-1 system</span>:
          </h3>

          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-3 mb-10" data-id="element-162" data-mp="22djo4m0wstsd">
            {finalIncludedItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-163" data-mp="1xhuhjyqh2cmk">
                <CheckIcon size={18} className="text-gold shrink-0 mt-0.5" data-id="element-164" data-mp="2behrd23iwx9w" />
                <span className="text-sm text-mist" data-id="element-165" data-mp="27dedgl51dbbb">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-166" data-mp="h0qbhkulph60">
            <div className="mb-8 p-6 bg-carbon-graphite rounded-xl border border-gold/30 italic text-mist text-lg" data-id="element-167" data-mp="h3kst3ibilv7">
              &quot;The best time to have this complete teaching system was before
              your very first BJJ class.
              <br data-id="element-168" data-mp="6y3328zk6ob9" />
              <span className="text-gold font-bold not-italic" data-id="element-169" data-mp="6wi66cpruta8">The second best time is today.</span>
              &quot;
            </div>
            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-170" data-mp="3p9gdx5st2qey">
              📚 Brazilian Jiu Jitsu Coach Ready — Complete 6-in-1 Teaching System
            </p>
            <p className="text-sm text-smoke mb-6" data-id="element-171" data-mp="3fclgyrc6ky2s">
              100 BJJ lessons ready to teach — designed to help instructors plan
              less, teach with confidence and keep every session truly structured
              and fresh.
            </p>
            <div className="mb-8" data-id="element-172" data-mp="3bbhzk0ehitzg">
              <p className="text-white font-bold uppercase tracking-[0.2em] text-sm md:text-base mb-4" data-id="element-173" data-mp="3bct6g9388hus">
                See it. Show it. <span className="text-gold" data-id="element-174" data-mp="14m3dwx2kcyv3">Teach it.</span>
              </p>
              <ValueBadges data-id="element-175" data-mp="19j3l5bb5g7ns" />
            </div>
            <div className="mb-6" data-id="element-176" data-mp="19i28x3iedf4h">
              <span className="text-base text-ash line-through mr-3" data-id="element-177" data-mp="35nt7wiseeawq">$105.00 USD</span>
              <span className="text-4xl font-extrabold text-gold" data-id="element-178" data-mp="30nyg8d0stham">$27.00 USD</span>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-179" data-mp="2vou69k61vfj8">
              {ctaLabelAccess}
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-smoke" data-id="element-180" data-mp="2mqrymlrt9omz">
              {trustItems.map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-181" data-mp="2cycg9nclqy1k">
                  <CheckIcon size={12} className="text-cta" data-id="element-182" data-mp="2cwj6w0altzpv" /> {item}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}